import React, { useState } from 'react';

import './AddCapsuleDropdown.scss';
import AddCapsuleMenuItems from 'widgets/tiles/components/AddCapsuleDropdown/AddCapsuleMenuItems';

import classNames from 'classnames';
import { useWidgetContext } from 'widgets/WidgetContext';
import useOnclickOutside from 'react-cool-onclickoutside';
import { WidgetCategory, widgetDropdownCategory } from 'widgets/WidgetCategory';
import { SearchInput } from '@instinet-analytics/semantic-ui-components';
import { useOnEscape } from '@instinet-analytics/core-lib';

export interface AddCapsuleDropdownProps {
    className?: string;
    dismiss: () => void;
}

export default function AddCapsuleDropdown(props: AddCapsuleDropdownProps) {
    const { className, dismiss } = props;

    const { width } = useWidgetContext();
    const [searchText, setSearchText] = useState('');
    useOnEscape(dismiss);

    const onClickOutside = (e: Event) => {
        const classList: DOMTokenList = (e.target as HTMLElement).classList;
        if (classList.contains('add-capsule-btn')) {
            return;
        }
        dismiss();
    };

    const ref = useOnclickOutside(onClickOutside);

    const columnWidth = 200;
    const cols = width > columnWidth * 2 - 26 ? 2 : 1;
    const panelWidth = columnWidth * cols + 26;

    const style = { width: panelWidth };

    const cssClasses = classNames(
        'AddCapsuleDropdown',
        className,
        'cols-' + cols
    );

    const catTop = widgetDropdownCategory(WidgetCategory.TOP);
    const catPrice = widgetDropdownCategory(WidgetCategory.PRICE_CAPSULES);
    const catAnalytics = widgetDropdownCategory(WidgetCategory.VOLUME_CAPSULES);
    const catFills = widgetDropdownCategory(WidgetCategory.FILL_CAPSULES);
    const catSignals = widgetDropdownCategory(WidgetCategory.SIGNAL_CAPSULES);

    const onInputChange = (text: string) => {
        setSearchText(text);
    };

    return (
        <div className={cssClasses} ref={ref} style={style}>
            <header>
                <div className="title">Available Capsules</div>
                <div className="search">
                    <SearchInput
                        value={searchText}
                        onChange={onInputChange}
                        placeholder="Search"
                    />
                </div>
            </header>
            <div className="items">
                {cols === 1 && (
                    <AddCapsuleMenuItems
                        onClick={dismiss}
                        categories={[
                            catTop,
                            catPrice,
                            catAnalytics,
                            catFills,
                            catSignals,
                        ]}
                        searchText={searchText}
                    />
                )}
                {cols === 2 && (
                    <>
                        <AddCapsuleMenuItems
                            onClick={dismiss}
                            categories={[catTop, catPrice, catAnalytics]}
                            searchText={searchText}
                        />
                        <AddCapsuleMenuItems
                            onClick={dismiss}
                            categories={[catFills, catSignals]}
                            searchText={searchText}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
